import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ShowcaseService } from 'src/app/services/showcase/showcase.service';

declare var $: any;

@Component({
  selector: 'app-showcase',
  templateUrl: './showcase.component.html',
  styleUrls: ['./showcase.component.scss']
})
export class ShowcaseComponent implements OnInit, AfterViewInit, OnDestroy {
  isLoading: boolean[] = [];
  defaultImgUrl: string[] = [
    '/assets/img/showcase/6.jpeg',
    '/assets/img/showcase/7.jpeg',
    '/assets/img/showcase/8.jpeg',
    '/assets/img/showcase/9.jpeg',
    '/assets/img/showcase/1.jpeg',
    '/assets/img/showcase/2.jpeg',
    '/assets/img/showcase/3.jpeg',
    '/assets/img/showcase/4.jpeg',
    '/assets/img/showcase/5.jpeg',
  ];
  imgUrl: string[] = [...this.defaultImgUrl];
  sub: Subscription;

  constructor(private showcaseService: ShowcaseService) { }

  ngOnInit(): void {
    this.fetchShowcase();
  }

  ngAfterViewInit(): void {
    this.initCarousel();
  }

  initCarousel(): void {
    if (typeof $ !== 'undefined' && $('#showcaseCarousel').length) {
      $('#showcaseCarousel').carousel({
        interval: 3000,
        pause: false
      });
    }
  }

  fetchShowcase(): void {
    this.sub = this.showcaseService.getShowcaseList().subscribe(
      items => {
        if (items && items.length > 0) {
          const fbSlides: { imgUrl: string, position: number }[] = [];
          items.forEach(item => {
            const data: any = item.payload.val() || {};
            const pos = data.position !== undefined ? Number(data.position) : 999;
            if (data.imgUrl) {
              fbSlides.push({
                imgUrl: data.imgUrl,
                position: isNaN(pos) ? 999 : pos
              });
            }
          });
          fbSlides.sort((a, b) => a.position - b.position);
          const fbUrls = fbSlides.map(s => s.imgUrl);
          this.imgUrl = [...fbUrls, ...this.defaultImgUrl];
          setTimeout(() => {
            this.initCarousel();
          }, 100);
        }
      },
      err => {
        console.warn('Error fetching showcase in TGS:', err);
      }
    );
  }

  setLoader(): void {
    this.isLoading = [];
    for (let i = 0; i < this.imgUrl.length; i++) {
      this.isLoading.push(true);
    }
  }

  hideLoader(i: number): void {
    this.isLoading[i] = false;
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
